import React from 'react'
import { useNavigate } from 'react-router'
import { IconChartBar, IconMap, IconHelpCircle, IconTemplate } from '@tabler/icons-react'
import Typography from '../../../atoms/Typography'
import { ROUTES } from 'src/types/routes'

interface AreaLimitMessageProps {
  onMinimize?: () => void
}

const AreaLimitMessage: React.FC<AreaLimitMessageProps> = ({ onMinimize }) => {
  const navigate = useNavigate()

  const handleUpgrade = () => {
    navigate(ROUTES.SUBS)
    // Minimize Copa window after navigating
    if (onMinimize) {
      onMinimize()
    }
  }

  return (
    <div className="flex w-full flex-col gap-[10px] p-3">
      {/* Message Title */}
      <Typography variant="sm-medium" className="whitespace-pre-wrap leading-[20px] text-[#EBF4F1]">
        Hey! It appears you&apos;ve reached the maximum project area for your current plan. Upgrade to continue managing
        your projects without limits.
      </Typography>

      {/* Upgrade Card */}
      <div className="flex w-full flex-col gap-4 rounded-[8px] border border-[#656E75] bg-[#1B1C1E] px-6 py-4">
        {/* Feature Items */}
        <div className="flex flex-col gap-4">
          {/* Unlimited project areas */}
          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconChartBar className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Unlimited project areas
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Create and manage as many projects as you need
              </Typography>
            </div>
          </div>

          {/* Advanced mapping tools */}
          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconMap className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Advanced mapping tools
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Access premium features and analysis capabilities
              </Typography>
            </div>
          </div>

          {/* Priority support */}
          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconHelpCircle className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Priority support
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Get help when you need it from our team
              </Typography>
            </div>
          </div>
        </div>

        {/* Upgrade Plan Button */}
        <button
          onClick={handleUpgrade}
          className="flex h-12 w-full items-center justify-center gap-3 rounded-[100px] bg-[#329175] px-8 py-4 transition-all duration-200 hover:brightness-110"
        >
          <IconTemplate className="h-5 w-5 text-[#F5F6F6]" stroke={1.5} />
          <Typography variant="base-medium" className="leading-[24px] text-[#F5F6F6]">
            Upgrade Plan
          </Typography>
        </button>
      </div>
    </div>
  )
}

export default AreaLimitMessage
